import React from 'react';
import ButtonOutline from '../../../app/common/components/ButtonOutline';
import OverlayDialog from '../../../app/common/components/OverlayDialog';
import Spinner from '../../../app/common/components/Spinner';
import ICONS from '../../../app/common/constants/icons';
import { COLORS } from '../../../app/common/constants/styles';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { IAddress } from '../address/address.interface';
import JPAddressContainer from '../address/JPAddressContainer';
import AddressFormContainerJP from '../addressFormJP/AddressFormContainerJP';
import {
    AddressListWrapper,
    SpinnerWrapper,
    List,
    IAddressListProps,
    IAddressListState,
} from '../addressList/AddressList';
import {
    updateChallengerLanguage,
    startChallenge,
    destroyChallenge,
} from '../../../utils/challengerMain';
import OverlayHelper from '../../../utils/overlayHelper';
import { PageId } from '../../../config/constants/pageId.enum';
import AddressUpdateInfo from './AddressUpdateInfo';
import HeadTitle from '../../../app/common/components/HeadTitle';

class JPAddressList extends React.Component<IAddressListProps, IAddressListState> {
    constructor(props: IAddressListProps) {
        super(props);

        this.state = {
            isOverlayOpen: false,
        };

        this.onOverlayClose = this.onOverlayClose.bind(this);
        this.createAddress = this.createAddress.bind(this);
        this.selectAddress = this.selectAddress.bind(this);
    }

    public componentDidMount() {
        window.scrollTo({ top: 0 });

        const { addresses, loading, getAddresses, challengerPid } = this.props;

        if (addresses.length < 1 && !loading) {
            getAddresses();
        }
        startChallenge(challengerPid);
    }

    public componentWillUnmount() {
        const { challengerPid } = this.props;
        destroyChallenge(challengerPid);
        OverlayHelper.closeHelper(PageId.address_jp);
    }

    public componentDidUpdate(prevProps: IAddressListProps) {
        const locale = this.props.locale;
        const prevLocale = prevProps.locale;

        if (locale !== prevLocale) {
            updateChallengerLanguage(locale);
        }
    }

    public render() {
        const {
            maxNumberOfAddress,
            addressCards,
            closeOverlay,
            addresses,
            formOpen,
            loading,
            getAddresses,
            challengerPid,
            locale,
            isJpRegion,
            updatedSuccess = false,
        } = this.props;
        const { selectedAddress } = this.state;
        let main;
        let addAddressButton;
        const showServiceAlert = isJpRegion && updatedSuccess;

        if (loading) {
            main = (
                <SpinnerWrapper>
                    <Spinner size={50} color={COLORS.white} qaId="loading-addresses" />
                </SpinnerWrapper>
            );
            addAddressButton = null;
        } else if (addresses) {
            const addressItems = addresses.map((address, index) => (
                <JPAddressContainer
                    address={address}
                    locale={locale}
                    cards={addressCards[address.addressUuid]}
                    key={index}
                    onEdit={this.selectAddress}
                    isOnlyAddress={addresses && addresses.length === 1}
                    qaId={`${index}`}
                />
            ));
            main = <List data-qa-id="address-list">{addressItems}</List>;
            const buttonId = 'add-address';
            addAddressButton =
                addresses.length >= maxNumberOfAddress ? null : (
                    <>
                        <ButtonOutline
                            id={buttonId}
                            text={TranslationHelpers.getMessageDescriptor('address.new')}
                            icon={ICONS.PLUS}
                            onClick={this.createAddress}
                            loading={loading}
                            disabled={loading}
                            data-qa-id={buttonId}
                        />
                    </>
                );
        } else {
            return null;
        }

        return (
            <>
                <AddressListWrapper>
                    <HeadTitle />
                    {main}

                    {showServiceAlert && <AddressUpdateInfo />}

                    {addAddressButton}

                    <OverlayDialog
                        title={TranslationHelpers.getMessageDescriptor(
                            selectedAddress ? 'address.edit' : 'address.new',
                        )}
                        isOpen={formOpen}
                        isLarge={true}
                        onClose={closeOverlay}
                    >
                        <AddressFormContainerJP
                            isOnlyAddress={!addresses || addresses.length === 0}
                            address={selectedAddress}
                            challengerPid={challengerPid}
                            onSubmit={() => {}}
                        />
                    </OverlayDialog>
                </AddressListWrapper>
            </>
        );
    }

    private createAddress() {
        const { openOverlay } = this.props;
        this.setState({
            selectedAddress: undefined,
        });
        openOverlay();
    }

    private selectAddress(address: IAddress) {
        const { openOverlay } = this.props;
        this.setState({
            selectedAddress: address,
        });
        openOverlay();
    }

    private onOverlayClose() {
        this.setState({
            selectedAddress: undefined,
        });
    }
}

export default JPAddressList;
